import axios from 'axios';

// const globalURL = 'https://devdesignerapi.azaonline.in/api/';
// const globalURL = 'https://stagedesignerapi.azaonline.in/api/';
const globalURL = 'https://designerapi.azaonline.in/api/';


export const loginAxios = axios.create({
    baseURL: globalURL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
  });
